// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'center',
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: '20px 0',
    width: 'fit-content',
    [theme.breakpoints.down(450)]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down(450)]: {
      marginBottom: 25,
      alignItems: 'flex-start',
    },
  },
  label: {
    marginTop: 10,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    letterSpacing: 1.05,
    maxWidth: 160,
    textAlign: 'center',
    [theme.breakpoints.down(450)]: {
      textAlign: 'left',
    },
  },
  print: {
    height: 71,
    width: 70,
  },
  pack: {
    height: 70,
    width: 70,
  },
  parcelshop: {
    width: 180,
    marginBottom: 5,
  },
  packLinkContainer: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    maxWidth: 150,
    textAlign: 'center',
    marginTop: 10,
    [theme.breakpoints.down(450)]: {
      textAlign: 'left',
    },
  },
  packLink: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    '&:hover': {
      textDecoration: 'none',
      color: GlobalStyles.color.COLOR_SECONDARY,
    },
  },
  packConstraintsContainer: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    maxWidth: 150,
    textAlign: 'center',
    marginTop: 10,
    [theme.breakpoints.down(450)]: {
      textAlign: 'left',
    },
  },
  yellowLine: {
    width: 70,
    borderWidth: 1,
    borderColor: GlobalStyles.color.COLOR_YELLOW_SELECT,
    borderStyle: 'solid',
    height: 0,
    marginTop: 30,
  },
  yellowLineVertical: {
    width: 0,
    borderWidth: 1,
    borderColor: GlobalStyles.color.COLOR_YELLOW_SELECT,
    borderStyle: 'solid',
    height: 400,
    marginBottom: 15,
    marginTop: 15,
    position: 'relative',
    marginRight: 30,
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginLeft: -4,
    backgroundColor: GlobalStyles.color.COLOR_YELLOW_SELECT,
  },
  circleNum1: {
    marginTop: -1,
  },
  circleNum2: {
    marginTop: 180,
  },
  circleNum3: {
    position: 'absolute',
    bottom: -1,
  }
});

export default styles;
